module.exports={"Clear search":"Limpar pesquisa"};